export default __webpack_public_path__ + "static/media/apdec.11d01ced.png";